import * as PIXI from 'pixi.js';
import { Game } from '../Game';

export class Scene {
  public readonly root: PIXI.Container;
  public readonly game: Game;

  constructor(game: Game) {
    this.game = game;
    this.root = new PIXI.Container();
    this.game.stage.addChild(this.root);
  }

  public destroy(): void {
    this.root.destroy({ children: true });
  }

  public handleResize(size: [number, number]): void {

  }

  public update(dt: number): void {
    //
  }
}
